'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = formSimpleTextInput;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formSimpleTextInput(props) {
  var input = props.input,
      _props$meta = props.meta,
      touched = _props$meta.touched,
      error = _props$meta.error,
      type = props.type,
      disabled = props.disabled,
      bottomHint = props.bottomHint,
      labelClass = props.labelClass,
      hideLabel = props.hideLabel,
      noIndent = props.noIndent,
      inputClassName = props.inputClassName,
      fieldClassName = props.fieldClassName,
      other = (0, _objectWithoutProperties3.default)(props, ['input', 'meta', 'type', 'disabled', 'bottomHint', 'labelClass', 'hideLabel', 'noIndent', 'inputClassName', 'fieldClassName']);

  var formGroupClassName = (0, _bind2.default)(fieldClassName, { hasError: touched && error, 'margin-vert-10': !noIndent });

  return _react2.default.createElement(
    'div',
    { className: formGroupClassName },
    props.placeholder && !hideLabel && _react2.default.createElement(
      'label',
      { className: labelClass },
      props.placeholder,
      ':'
    ),
    type === 'textarea' ? _react2.default.createElement('textarea', (0, _extends3.default)({}, other, input, { disabled: disabled, className: (0, _bind2.default)('width-perc-100', inputClassName) })) : _react2.default.createElement('input', (0, _extends3.default)({}, other, input, { type: type, disabled: disabled, className: (0, _bind2.default)('width-perc-100', inputClassName) })),
    touched && error && _react2.default.createElement(
      'div',
      { className: 'fieldErrorText' },
      error
    ),
    bottomHint && _react2.default.createElement(
      'div',
      { className: 'hint small' },
      bottomHint
    )
  );
}

formSimpleTextInput.propTypes = {
  bottomHint: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  fieldClassName: _propTypes2.default.string,
  hideLabel: _propTypes2.default.bool,
  input: _propTypes2.default.object,
  inputClassName: _propTypes2.default.string,
  labelClass: _propTypes2.default.string,
  meta: _propTypes2.default.object,
  noIndent: _propTypes2.default.bool,
  placeholder: _propTypes2.default.string,
  type: _propTypes2.default.string
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/formComponents/formSimpleTextInput.js
// module id = 2138
// module chunks = 1